import { render } from "./Banner.vue?vue&type=template&id=50288dc4&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"

import "./Banner.vue?vue&type=style&index=0&id=50288dc4&scoped=true&lang=css"

import exportComponent from "/workspace/wum/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50288dc4"]])

export default __exports__